module.exports = "/_next/static/images/d703e0484ef4c84af694fe86ab8ec1b4-defer-xs.png";